import React, { useState } from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";
import phoneBg from "../images/phone_female.png";
import countries from "../data/countries.json";

const Step3 = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");

  const validatePhone = () => {
    if (!countryCode) return "Please select your country.";
    if (!/^\d{6,}$/.test(phoneNumber))
      return "Phone number must be at least 6 digits.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const validationError = validatePhone();
    if (validationError) {
      setError(validationError);
      return;
    }

    const finalPhone = `${countryCode} ${phoneNumber}`;

    try {
      const response = await fetch(
         `http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone: finalPhone,
            current_step: "4", // <----- WAJIB: tracking progress
          }),
        }
      );

      if (response.ok) {
        setTimeout(() => {
          window.location.href = "/step4";
        }, 700);
      } else {
        alert("Failed to save phone number");
      }
    } catch (err) {
      console.error("Error updating phone:", err);
      alert("Server connection error");
    }
  };

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-blue-800 via-blue-700 to-blue-400 text-white px-4">
      
      {/* BACKGROUND IMAGE */}
      <img
        src={phoneBg}
        className="absolute top-26 right-40 opacity-50 w-72 md:w-96 select-none pointer-events-none"
        alt="background"
      />

      <div className="w-full max-w-lg mt-6 z-10">
        <ProgressBar step={3} />
      </div>

      <motion.h1
        className="text-3xl md:text-3xl font-extrabold mt-12 mb-10 text-center text-yellow-300 drop-shadow-md z-10"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        What's your phone number?
      </motion.h1>

      <form
        onSubmit={handleSubmit}
        className="bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-xl w-full max-w-md z-10"
      >
        {/* COUNTRY SELECT */}
        <label className="text-sm text-yellow-200 font-semibold">
          Country
        </label>

        <select
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-lg border-2 border-yellow-300 text-blue-900 font-semibold text-lg focus:outline-none"
        >
          <option value="">Select your country</option>

          {countries.map((c, i) => (
            <option key={i} value={c.code}>
              {c.name} ({c.code})
            </option>
          ))}
        </select>

        {/* PHONE NUMBER INPUT */}
        <label className="text-sm text-yellow-200 font-semibold mt-2 block">
          Phone Number
        </label>

        <input
          type="text"
          placeholder="812345678"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ""))}
          className="w-full mt-1 px-4 py-3 rounded-lg border-2 border-yellow-300 text-blue-900 font-semibold text-lg focus:outline-none"
        />

        {error && (
          <p className="text-red-200 text-sm mt-2 text-center">{error}</p>
        )}

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          type="submit"
          className="mt-6 w-40 bg-yellow-400 text-blue-900 font-bold py-3 rounded-lg shadow-md hover:bg-yellow-300 transition"
        >
          Continue
        </motion.button>
      </form>
	  
	  {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step3;
